import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import Modal from "../modal";
import { notifyMobileApp } from "../../utils/biling-util";
const {
  STRIPE: { PRICES },
} = require("../../constants");

function PlanSwitchConfirmationModal(props, { locals }) {
  const { activeUser, momentTZ, query, invoice, activeUserToRequest } = locals;
  const { reactivate } = query;
  const planChange = get(query, "changed", false);
  const coupon = get(activeUserToRequest, "stripe.coupon");
  // The proration is the first line, the charge is the second line
  const invoiceData = invoice.invoice.lines.data;
  const subtotal = invoice.invoice.subtotal;
  const amountDue = invoice.invoice.amount_due;

  let plan, price;
  switch (activeUserToRequest.stripe.plan) {
    case "launch_twelveMonth":
      plan = "Twelve Month Subscription";
      price = PRICES.twelveMonths;
      break;
    case "launch_threeMonth":
      plan = "Three Month Subscription";
      price = PRICES.threeMonths;
      break;
    case "launch_oneMonth":
      plan = "Monthly Subscription";
      price = PRICES.oneMonth;
      break;
    case "v2_premium_monthly":
      plan = "Premium Monthly Subscription";
      price = PRICES.v2_premium_monthly;
      break;
    case "v2_premium_annually":
      plan = "Premium Annual Subscription";
      price = PRICES.v2_premium_annually;
      break;
    case "v2_standard_monthly":
      plan = "Standard Monthly Subscription";
      price = PRICES.v2_standard_monthly;
      break;
    case "v2_standard_annually":
      plan = "Standard Annual Subscription";
      price = PRICES.v2_standard_annually;
      break;
    default:
  }
  const isPremium =
    plan === "Premium Annual Subscription" ||
    plan === "Premium Monthly Subscription";

  // Calculate amount
  let prorationAmount = 0;
  if (
    Math.abs(invoice.invoice.starting_balance) > invoice.invoice.subtotal ||
    invoice.invoice.amount_due == 0
  ) {
    // User has more credit in their account than the cost of switching plans
    prorationAmount = (price / 100).toFixed(2);
  } else {
    prorationAmount = Math.abs(invoiceData[0].amount / 100).toFixed(2);
  }

  return (
    <Modal width="600px">
      <div className="head">
        <h2 className="alt">
          {reactivate ? "REACTIVATION" : "PLAN SWITCH"} CONFIRMATION
        </h2>
      </div>
      {reactivate && !planChange ? (
        <div className="body">
          <div className="columns">
            <div className="column" data-col="1/1">
              {plan === "Premium Annual Subscription" ||
                (plan === "Premium Monthly Subscription" && (
                  <p>Thank you {activeUser.name}! </p>
                ))}
              <p>
                You have successfully reactivated your subscription to the{" "}
                <b>{plan}</b>.{" "}
              </p>
              <p>
                Your membership is valid through{" "}
                <b>
                  {momentTZ(activeUserToRequest.stripe.period_end).format(
                    "MMM. DD, YYYY"
                  )}
                </b>
                , at which point your subscription will be renewed and your card
                will be charged{" "}
                <b>${amountDue > 0 ? (subtotal / 100).toFixed(2) : "0.00"}</b>.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="body">
          <div className="columns">
            <div className="column" data-col="1/1">
              {isPremium && <p>Thank you {activeUser.name}! </p>}
              <p>
                You have successfully changed your subscription to the{" "}
                <b>{plan}</b>. A prorated amount of <b>${prorationAmount}</b>{" "}
                from your account has been applied to offset the cost of your
                new subscription. Your card has been charged{" "}
                <b>${amountDue > 0 ? (subtotal / 100).toFixed(2) : "0.00"}</b>{" "}
                and your membership is valid through to{" "}
                <b>
                  {momentTZ(activeUserToRequest.stripe.period_end).format(
                    "MMM. DD, YYYY"
                  )}
                </b>
                .
              </p>
              <p>
                Your subscription will renew at the end of the billing cycle.
              </p>
            </div>
          </div>
        </div>
      )}
      <div className="foot">
        <a
          className="button"
          onClick={() => notifyMobileApp()}
          href="/dashboard/settings/subscription"
        >
          Close
        </a>
      </div>
    </Modal>
  );
}

PlanSwitchConfirmationModal.contextTypes = { locals: PropTypes.object };

export default PlanSwitchConfirmationModal;
